import { observable } from 'rewire-core';
import { IMessage, MessageUpdateInput } from '../DataTypes';
import DataMutations from '../graphql/Mutations';
import { notifications } from '../ui/Notifications';

export default class MessagesModel {
  messages: IMessage[];

  private constructor() {}

  static create(): MessagesModel {
    return observable(new MessagesModel()).initialize();
  }

  initialize() {
    this.messages = [];
    return this;
  }

  reset() {
    this.messages.length = 0;
  }

  set(messages: IMessage[]) {
    this.reset();
    this.messages.set(messages);
  }

  get errorMessages(): IMessage[] {
    return this.messages.filter((m) => m.level === 'error');
  }

  get warningMessages(): IMessage[] {
    return this.messages.filter((m) => m.level === 'warning');
  }

  get infoMessages(): IMessage[] {
    return this.messages.filter((m) => m.level === 'info');
  }

  get successMessages(): IMessage[] {
    return this.messages.filter((m) => m.level === 'success');
  }

  private findMatchingMessage = (message: IMessage): IMessage | undefined => {
    const matchingMessage = this.messages.find((m) => m.id === message.id);
    return matchingMessage;
  };

  add = (message: IMessage) => {
    const matchingMessage = this.findMatchingMessage(message);
    if (!matchingMessage) {
      this.messages.push(message);
      this.messages.sort((t1, t2) => (!t1 || !t2 ? 0 : t1.effective! < t2.effective! ? -1 : 1));
    }
  };

  remove = (message: IMessage) => {
    const matchingMessage = this.findMatchingMessage(message);
    if (matchingMessage) {
      const index = this.messages.indexOf(matchingMessage);
      this.messages.splice(index, 1);
    }
  };

  removeForId = (id: string) => {
    this.messages.filter((m) => m.id.startsWith(id)).forEach(this.remove);
  };
}

export async function deleteMessages(messages: IMessage[], id: string) {
  if (await DataMutations.deleteMessages([id])) {
    const idx = messages.findIndex((m) => m.id === id);
    if (idx >= 0) messages.splice(idx, 1);
  }
}

export async function saveMessage(messages: IMessage[], message: IMessage) {
  if (!message.id) {
    return;
  }
  try {
    const m: MessageUpdateInput = {
      id: message.id,
      text: message.text,
      // level: message.level,
      // type: message.type,
      // effective: message.effective,
      // employeeId: message.employee?.id,
      // jobId: message.jobId,
    };
    await DataMutations.updateMessages('', [m]);
    const mes = messages.find((m) => m.id === message.id);
    if (mes) {
      Object.assign(mes, message);
    }
  } catch (error) {
    notifications.error(`Failed to save message: ${error.message || error}`);
    return false;
  }
  return true;
}
